import { axios } from '../util/request'
axios.defaults.headers.common['Content-Type'] = 'application/json';
const BASE_URL = process.env.NODE_ENV === 'development' ? '/api' : '/api'
import Qs from 'qs'

const CHAT_API_DATA = {
  //获取介绍
  introduce: () => {
    return axios({
      url: `${BASE_URL}/group/introduce`,
      method: 'POST'
    })
  },
  //获取聊天记录
  getMessageList: (data) => {
    data = Qs.stringify(data)
    return axios({
      url: `${BASE_URL}/group/getMessageList`,
      method: 'POST',
      data
    })
  },
  //获取与我相关
  getMyMessageList: (data) => {
    data = Qs.stringify(data)
    return axios({
      url: `${BASE_URL}/group/getMyMessageList`,
      method: 'POST',
      data
    })
  },
  //获取管理员签名
  getAdminUserSig: (data) => {
    return axios({
      url: `${BASE_URL}/group/getUserSig`,
      method: 'GET',
      params: {
        num: data.num
      }
    })
  },
  //获取用户签名
  getUserSig: (data) => {
    data = Qs.stringify(data)
    return axios({
      url: `${BASE_URL}/group/getUserSigByAccount`,
      method: 'POST',
      data
    })
  },
  //导入单个账号
  importAccount: (data) => {
    data = Qs.stringify(data)
    return axios({
      url: `${BASE_URL}/group/importAccount`,
      method: 'POST',
      data
    })
  },
  //加入群
  addGroup: (data) => {
    data = Qs.stringify(data)
    return axios({
      url: `${BASE_URL}/group/addGroup`,
      method: 'POST',
      data
    })
  },
  //未读提醒
  userUnRead: () => {
    return axios({
      url: `${BASE_URL}/group/userUnRead`,
      method: 'POST'
    })
  },
  //发送消息
  sendMessage: (data) => {
    data = Qs.stringify(data)
    return axios({
      url: `${BASE_URL}/group/sendMessage`,
      method: 'POST',
      data
    })
  },
  //删除接口
  delMessage: (messageId) => {
    data = Qs.stringify(messageId)
    return axios({
      url: `${BASE_URL}/group/delMessage`,
      method: 'POST',
      data
    })
  },
  //客户评价
  solve: (data) => {
    let DATA = Qs.stringify(data)
    return axios({
      url: `${BASE_URL}/group/solve`,
      method: 'POST',
      data: DATA
    })
  },
  // 获取提示语
  getTips: () => {
    return axios({
      url: `${BASE_URL}/tips/all`,
      method: 'GET'
    })
  },
  // 获取服务状态
  isWork: () => {
    return axios({
      url: `${BASE_URL}/tips/isGoOffWork`,
      method: 'GET'
    })
  },
  // 查看消息锁定状态
  checkLock: (data) => {
    // let arr = data.split(',')
    return axios({
      url: `${BASE_URL}/group/getByIdList`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      data: data
    })
  }
}

export { CHAT_API_DATA }